import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/services/user.service';
import { JobRole,getJobRoleDetails, loadSelectedJobRoleData, jobRolePermissions, MenuListVM, JobRoleTable } from '../../entities';
import { NotificationsService } from 'angular2-notifications';
//import { SelectionModel } from '@angular/cdk/collections';
import { MatListOption } from '@angular/material/list';
import { MatTableDataSource } from '@angular/material/table';
import { CryptoService } from '../../services/crypto.service';

@Component({
  selector: 'app-jobrole-permissions',
  templateUrl: './jobrole-permissions.component.html',
  styleUrls: ['./jobrole-permissions.component.scss']
})
export class JobrolePermissionsComponent implements OnInit {
  constructor(private _userService: UserService, private _notify: NotificationsService, private _crypto: CryptoService) { }

btnDisabledAdd :boolean;
btnDisabledUpdate:boolean;
btnDisabledDelete:boolean;
isShowIcon: boolean; 
isShowIcon_: boolean; 

PermissionMneuData:jobRolePermissions;
menuL1:MenuListVM[]=[];
menuL2:MenuListVM[]=[];
menuL3:MenuListVM[]=[];

JobRoleTable:JobRoleTable[];

jobRoleDetails:getJobRoleDetails[]
jobRoleList: getJobRoleDetails;
jobroleID;
roleName;
isActive
createdBy;
roleNotes;
isCanchangeGroup;
selectedOptionsMenu1:boolean;
//selection = new SelectionModel(true, []);
displayedColumns: string[] = ['UserName', 'Name','startDate', 'Active'];
isAdminAllowEdit:boolean=true;
  dataSource = new MatTableDataSource();

  ngOnInit() {
    this.loadUserJobRoles();
    this.onClear()
  }

  loadUserJobRoles() {
        this._userService.GetAllJobRoles().subscribe(roles => {
          console.log("jobroles", roles)
          this.jobRoleList=roles;
        });
  }

  resetFields(){
        this.jobroleID = "";
        this.createdBy = "";
        this.roleName="";
        this.isActive ="";
        this.roleNotes="";
        this.isCanchangeGroup="";
        this.menuL1=[];
        this.menuL2_=[];
        this.menuL3_=[];
        this.dataSource.data=[];
        this.isAdminAllowEdit=false;
        this.onClear()
    }

    change(option: MatListOption)
    {
      console.log(option.selected);
    }
  
 
    getJobRole(){
      console.log("jobroleID", this.jobroleID)
      this._userService.getJobroleDetails(this.jobroleID).subscribe(r => { 
      console.log("job Role Details", r)
        this.createdBy = this._crypto.decrypt(r.createdByUser);
      this.roleName=r.RoleName;
      this.isActive=r.Active;
      this.roleNotes=r.RoleNote;
      this.isCanchangeGroup=r.ChangeGroup
      this.isAdminAllowEdit=r.AllowEdit;     
    }); 
   }

   GetUserTable()
   {
    this._userService.GetUserTable(this.jobroleID).subscribe(res=>
     
       {
        console.log('table details',this.jobroleID )
           console.log('Jobrole table details', res)
           this.JobRoleTable=res;
           this.dataSource.data = this.JobRoleTable;

       })
   }
   addNewJobrole()
   {
    let model = new getJobRoleDetails(); 
    
    model.RoleName=this.roleName;  
    model.Active=this.isActive;
    model.RoleNote=this.roleNotes;
    model.ChangeGroup=this.isCanchangeGroup; 
    model.AllowEdit = this.isAdminAllowEdit;
    this._userService.addNewJobroleDetails(model).subscribe(r => {
      console.log("result", r)
      if(r==true){
      
      console.log("Added new job Role ", r)
      this._notify.success('Add new role');

     }
     else{
       this._notify.error('Job Role already exists');
      console.log('update failed')

      }

    });
    this.loadUserJobRoles();
   }

   updateJobrole()   
   { 
    let model = new getJobRoleDetails(); 
    model.JobRoleId=this.jobroleID;
    model.RoleName=this.roleName;  
    model.Active=this.isActive;
    model.RoleNote=this.roleNotes;
    model.ChangeGroup=this.isCanchangeGroup; 
    model.AllowEdit = this.isAdminAllowEdit;
    this._userService.updateJobroleDetails(model).subscribe(r => {
      console.log("result", r)
          
      console.log("updated job Role Details", r)
      this._notify.success('Saved','Updated Job Roles');
      

    });
    this.loadUserJobRoles();
   
   }

deleteJobrole()
{
  this._userService.deleteJobroleDetails(this.jobroleID).subscribe(r => {
    
      this._notify.success('Remove Job Role');
    
  }); 
  this.loadUserJobRoles();
  this.resetFields();

}

menuLink1__:MenuListVM[]=[];
IDmenu2

getMenuforSelectedJobrole()
{
  this._userService.GETMenuForSlectedJobRole(this.jobroleID).subscribe(r=> {

    console.log('result', r)
this.PermissionMneuData = r;
this.menuL1= this.PermissionMneuData.Menu_L1;
this.menuL2= this.PermissionMneuData.Menu_L2;
this.menuL3= this.PermissionMneuData.Menu_L3;
  })
}

menuL2_: MenuListVM[]=[];
menuL3_: MenuListVM[]=[];
clickMenulinkOne(menulink1:MenuListVM){
  console.log("menuselected", menulink1)
  this.menuL2_ = this.PermissionMneuData.Menu_L2.filter(x=>x.linkMenuL1==menulink1.ID);
  console.log("menu 2",this.menuL2_)
  this.menuL3_=[];
}


showicon(m1:MenuListVM) : boolean
{
  this.isShowIcon=false;
//console.log("showIcon")
    for(let j=0; j<this.menuL2.length; j++){
         
      if(m1.ID==this.menuL2[j].linkMenuL1){
        this.isShowIcon=true;
        break;       

          }
    }

  return this.isShowIcon;
}

showicon_(m2:MenuListVM) : boolean
{
  this.isShowIcon_=false;
  for(let j=0; j<this.menuL3.length; j++){
         
    if(m2.ID==this.menuL3[j].linkMenuL2){
      this.isShowIcon_=true;
      break;       

        }
  }

  return this.isShowIcon_;
}

clickMenulinkTwo(menulink2:MenuListVM){
  console.log("menuselected", menulink2)
  this.menuL3_ = this.PermissionMneuData.Menu_L3.filter(x=>x.linkMenuL2==menulink2.linkMenuL2);
  console.log("menu 3",this.menuL3_)
  
}
 
checkBoxClick(menulink:MenuListVM){
menulink.Active = !menulink.Active;
}

updatemenul2:MenuListVM[]=[]
updateMenu(){
  
  this.PermissionMneuData.Menu_L1 = this.menuL1;
  this.PermissionMneuData.Menu_L2 = this.menuL2;
  this.PermissionMneuData.Menu_L3 = this.menuL3;
 
this._userService.updateActiveStatus(this.PermissionMneuData).subscribe(res=>{
  console.log("res",res)
  if(res==true){
    this._notify.success("Updated Sucessfully")
  }
})

}

    resetMenu1andMenu2()
    {
      this.menuL2_=[];
      this.menuL3_=[];
      this.btnDisabledAdd = true;
        this.btnDisabledUpdate=false;
        this.btnDisabledDelete=false;

      
    }
    updateAllComplete(){
      console.log("ress_click")
    }

    onClear()
    {
     
        this.jobroleID = "";
       
        this.roleName="";
        this.isActive ="";
        this.roleNotes="";
        this.isCanchangeGroup="";
        this.menuL1=[];
        this.menuL2=[];
        this.menuL2=[];
        this.dataSource.data=[];
        this.btnDisabledAdd = false;
        this.btnDisabledUpdate=true;
        this.btnDisabledDelete=true;

      
  }
  manageResetPassword() {

  }

}

